import React from "react"
import "../App.css"

function formatTime(date: Date): string {
  return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
}

function formatLine(lineId: string): string {
  return lineId.includes("tram-21") ? "21" : lineId
}
function interval(date: Date): number {
  return Math.round((date.getTime() - new Date().getTime()) / 1000 / 60)
}

export default function Departure(props: {
  direction: string
  line: string
  when: Date
}) {
  return (
    <tr>
      <td>
        <strong>{interval(props.when)}&apos;</strong> {formatTime(props.when)}
      </td>
      <td>{props.direction}</td>
      <td>{formatLine(props.line)}</td>
    </tr>
  )
}
